<template>
  <div class="add-supplement-dialog">
    <Dialog :canCloseWithEsc="true" :width="componentFrom === 'protocol' ? '1500' : '1000'" scrollable>
      <template slot="title">
        <div>{{dialog.title}}</div>
      </template>
      <template slot="body">
        <v-form ref="form" v-model="valid" lazy-validation id="addSupplement" class="py-2 pl-3 pr-3">
          <v-row>
            <template v-if="componentFrom === 'protocol'">
              <v-col cols="4" :style="{'margin-top': componentFrom === 'tab-supplement' ? '10px' : '32px'}">
                <v-row class="d-flex align-center">
                  <v-col cols="12">
                    <div class="d-flex align-center justify-end" v-if="componentFrom === 'tab-supplement'">
                      <span class="supply-days__title">Supply days</span>
                      <span class="supply-days__count ml-1">60</span>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col class="pb-0 pt-0">
                    <div v-if="dialog.name !== 'editSupplementDialog'"  class="add-supplement-dialog__label mb-1" style="margin-top: -22px">Search for Supplement</div>
                    <div v-if="dialog.name === 'editSupplementDialog'" class="ml-2 mt-2 mb-2" style="margin-top: -22px">
                      <span style="font-style: normal;font-weight: 600;font-size: 20px;">{{searchValue}}</span>
                    </div>
                    <Input outlined
                           radius="8"
                           placeholder="New supplement name"
                           v-if="dialog.name === 'addSupplementDialog' && componentFrom !== 'protocol'"
                           @input="form.name=$event"
                           :value="form.name"
                           :rules="notEmtpy"/>
                    <Input outlined
                           radius="8"
                           :value="form.name"
                           placeholder="New supplement name"
                           v-if="dialog.name === 'editSupplementDialog' && componentFrom !== 'protocol'"
                           @input="form.name=$event"
                           :rules="notEmtpy"/>
                    <Input outlined
                           radius="8"
                           placeholder="New supplement name"
                           v-if="dialog.name === 'editSupplementDialog' && componentFrom === 'protocol'"
                           @input="form.supplementName=$event"
                           disabled
                           :value="form.supplementName"
                           :rules="notEmtpy"/>
                    <search-select @update:search="searchValue=$event"
                                   @change:object="form.supplementId=$event.id, form.name=$event.name"
                                   placeholder="Enter supplement name"
                                   itemText="name"
                                   itemValue="name"
                                   :value="form.name"
                                   :items="supplements"
                                   returnObject
                                   :rules="notEmtpy"
                                   v-if="dialog.name === 'addSupplementDialog' && componentFrom === 'protocol'"
                                   :background-color="'#EDF2F7'"
                    />
                  </v-col>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :title="'Days Per Week'"
                    :countBtns="7"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.daysPerWeek"
                    @setData="form.daysPerWeek = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'upon-arising'"
                    :title="'Upon Arising'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosageUponArising"
                    @setData="form.dosageUponArising = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'breakfast'"
                    :title="'Breakfast'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosageBreakfast"
                    @setData="form.dosageBreakfast = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'10am'"
                    :title="'10 am'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosage10am"
                    @setData="form.dosage10am = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'lunch'"
                    :title="'Lunch'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosageLunch"
                    @setData="form.dosageLunch = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'3pm'"
                    :title="'3 pm'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosage3pm"
                    @setData="form.dosage3pm = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'dinner'"
                    :title="'Dinner'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosageDinner"
                    @setData="form.dosageDinner = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'7pm'"
                    :title="'7 pm'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosage7pm"
                    @setData="form.dosage7pm = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'before-sleep'"
                    :title="'Before Sleep'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosageBeforeSleep"
                    @setData="form.dosageBeforeSleep = $event"
                  ></custom-radio-button>
                </v-row>
              </v-col>
              <v-col cols="4">
                <template v-if="componentFrom === 'tab-supplement'">
                  <v-row class="add-supplement-dialog__label justify-center mt-3">Supplement Details</v-row>
                  <v-row class="pl-2 pr-3 mb-2" style="margin-top: -22px">
                    <v-col class="pb-0 mb-2 pt-1">
                      <div class="d-flex add-supplement-dialog__bp">
                        <v-checkbox
                          class="pt-1 pb-1"
                          color="#008C89"
                          v-model="form.vegetarian"
                          label="Vegetarian"/>
                        <v-checkbox
                          color="#008C89"
                          class="pt-1 pb-1"
                          v-model="form.glutenFree"
                          label="Gluten free"/>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="pl-2 pr-3 mb-2" style="margin-top: -35px;">
                    <v-col class="pb-0 mb-2 pt-1">
                      <div class="d-flex add-supplement-dialog__bp">
                        <v-checkbox
                          class="pt-1 pb-1"
                          color="#008C89"
                          v-model="form.warningLowBP"
                          label="Warning low BP"/>
                        <v-checkbox
                          color="#008C89"
                          class="pt-1 pb-1"
                          v-model="form.warningHighBP"
                          label="Warning high BP"/>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="pl-2 pr-3 mb-2" style="margin-top: -15px">
                    <v-col class="pb-0 pt-1">
                      <div class="add-supplement-dialog__label">Quantity Type</div>
                      <Select
                        outlined
                        itemText="text"
                        itemValue="id"
                        radius="8"
                        :items="quantityTypes"
                        :value="form.quantityType || quantityTypes[0].code"
                        @change="form.quantityType = $event"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="pl-2 pr-3 mb-2" style="margin-top: -25px">
                    <v-col class="pb-0 mb-2 pt-1">
                      <div class="d-flex add-supplement-dialog__bp">
                        <v-checkbox
                          color="#008C89"
                          class="pt-1 pb-1"
                          v-model="form.printShortDescriptionReports"
                          label="Print my Short Description on Reports"/>
                      </div>
                    </v-col>
                  </v-row>
                </template>
                <v-row class="add-supplement-dialog__label justify-center"
                       :style="{'margin-top': componentFrom === 'tab-supplement' ? '10px' : '8px'}">
                  {{componentFrom === 'protocol' ? 'Notes for this Protocol' : 'Supplement Notes'}}
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <v-expansion-panels flat v-model="computedPanel" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Patient Note (English)
                      </v-expansion-panel-header>
                      <v-expansion-panel-content color="#EDF2F7">
                        <Textarea dense auto-grow rows="1" rows-height="4" outlined @input:text-area="form.patientNotes=$event" :value="form.patientNotes" />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Patient Note (Spanish)
                      </v-expansion-panel-header>
                      <v-expansion-panel-content color="#EDF2F7">
                        <Textarea dense auto-grow rows="1" rows-height="4" outlined @input:text-area="form.patientNotesSpanish=$event" :value="form.patientNotesSpanish" />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        My internal Notes
                      </v-expansion-panel-header>
                      <v-expansion-panel-content color="#EDF2F7">
                        <Textarea rows="1" rows-height="4" dense auto-grow outlined @input:text-area="form.clinicianNotes=$event" :value="form.clinicianNotes" />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>
              </v-col>
              <v-col cols="4">
                <template v-if="componentFrom === 'tab-supplement'">
                  <v-row class="add-supplement-dialog__label justify-center mt-3">Supplement Details</v-row>
                  <v-row class="pl-2 pr-3 mb-2" style="margin-top: -22px">
                    <v-col class="pb-0 mb-2 pt-1">
                      <div class="d-flex add-supplement-dialog__bp">
                        <v-checkbox
                          class="pt-1 pb-1"
                          color="#008C89"
                          v-model="form.vegetarian"
                          label="Vegetarian"/>
                        <v-checkbox
                          color="#008C89"
                          class="pt-1 pb-1"
                          v-model="form.glutenFree"
                          label="Gluten free"/>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="pl-2 pr-3 mb-2" style="margin-top: -35px;">
                    <v-col class="pb-0 mb-2 pt-1">
                      <div class="d-flex add-supplement-dialog__bp">
                        <v-checkbox
                          class="pt-1 pb-1"
                          color="#008C89"
                          v-model="form.warningLowBP"
                          label="Warning low BP"/>
                        <v-checkbox
                          color="#008C89"
                          class="pt-1 pb-1"
                          v-model="form.warningHighBP"
                          label="Warning high BP"/>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="pl-2 pr-3 mb-2" style="margin-top: -15px">
                    <v-col class="pb-0 pt-1">
                      <div class="add-supplement-dialog__label">Quantity Type</div>
                      <Select
                        outlined
                        itemText="text"
                        itemValue="id"
                        radius="8"
                        :items="quantityTypes"
                        :value="form.quantityType || quantityTypes[0].code"
                        @change="form.quantityType = $event"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="pl-2 pr-3 mb-2" style="margin-top: -25px">
                    <v-col class="pb-0 mb-2 pt-1">
                      <div class="d-flex add-supplement-dialog__bp">
                        <v-checkbox
                          color="#008C89"
                          class="pt-1 pb-1"
                          v-model="form.printShortDescriptionReports"
                          label="Print my Short Description on Reports"/>
                      </div>
                    </v-col>
                  </v-row>
                </template>
                <v-row class="add-supplement-dialog__label justify-center"
                       :style="{'margin-top': componentFrom === 'tab-supplement' ? '10px' : '8px'}">Supplement Notes</v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <v-expansion-panels flat v-model="panelSupplementNotes" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Patient Note (English)
                      </v-expansion-panel-header>
                      <v-expansion-panel-content color="#EDF2F7">
                        <Textarea disabled dense auto-grow rows="1" rows-height="4" outlined @input:text-area="supplementNotes.patientEnglish=$event" :value="supplementNotes.patientEnglish" />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Patient Note (Spanish)
                      </v-expansion-panel-header>
                      <v-expansion-panel-content color="#EDF2F7">
                        <Textarea disabled dense auto-grow rows="1" rows-height="4" outlined @input:text-area="supplementNotes.patientSpanish=$event" :value="supplementNotes.patientSpanish" />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        My internal Notes
                      </v-expansion-panel-header>
                      <v-expansion-panel-content color="#EDF2F7">
                        <Textarea disabled rows="1" rows-height="4" dense auto-grow outlined @input:text-area="supplementNotes.internal=$event" :value="supplementNotes.internal" />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>
                <v-row>
                  <v-col class="py-0">
                    <div class="d-flex justify-space-between">
                      <Button :styles="{ 'border-radius': '8px', 'border': '1px solid #EDF2F7', 'background': 'white' }"
                              width="99"
                              height="53"
                              @click="close">
                        <span style="color: #425466;font-weight: 600;font-size: 14px;">Cancel</span>
                      </Button>
                      <Button btn-bg="dark-green"
                              dark
                              width="180"
                              height="53"
                              :disabled="!form.name"
                              :styles="{ 'border-radius': '8px', 'font-weight': '600' }"
                              v-if="dialog.name == 'addSupplementDialog'"
                              @click="add">
                        <span>Save</span>
                      </Button>
                      <Button btn-bg="dark-green"
                              dark
                              width="180"
                              height="53"
                              :styles="{ 'border-radius': '8px', 'font-weight': '600' }"
                              v-else
                              @click="update">
                        <span>Update</span>
                      </Button>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </template>
            <template v-else>
              <v-col cols="6" :style="{'margin-top': componentFrom === 'tab-supplement' ? '0px' : '32px'}">
                <v-row class="d-flex align-center">
                  <v-col cols="12">
                    <div class="d-flex align-center justify-end" v-if="componentFrom === 'tab-supplement'">
<!--                      <span class="supply-days__title">Supply days</span>
                      <span class="supply-days__count ml-1">60</span>-->
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col class="pb-0 pt-0">
                    <div v-if="dialog.name !== 'editSupplementDialog'"  class="add-supplement-dialog__label mb-1">Enter supplement</div>
                    <div v-if="dialog.name === 'editSupplementDialog'" class="ml-2 mt-2 mb-2">
                      <span style="font-style: normal;font-weight: 600;font-size: 20px;">{{searchValue}}</span>
                    </div>
                    <Input outlined
                           radius="8"
                           placeholder="New supplement name"
                           v-if="dialog.name === 'addSupplementDialog' && componentFrom !== 'protocol'"
                           @input="form.name=$event"
                           :value="form.name"
                           :rules="notEmtpy"/>
                    <Input outlined
                           radius="8"
                           :value="form.name"
                           placeholder="New supplement name"
                           v-if="dialog.name === 'editSupplementDialog' && componentFrom !== 'protocol'"
                           @input="form.name=$event"
                           :rules="notEmtpy"/>
                    <Input outlined
                           radius="8"
                           placeholder="New supplement name"
                           v-if="dialog.name === 'editSupplementDialog' && componentFrom === 'protocol'"
                           @input="form.supplementName=$event"
                           :value="form.supplementName"
                           :rules="notEmtpy"/>
                    <search-select @update:search="searchValue=$event"
                                   @change:object="form.supplementId=$event.id, form.name=$event.name"
                                   placeholder="Enter supplement name"
                                   itemText="name"
                                   itemValue="name"
                                   :value="form.name"
                                   :items="supplements"
                                   returnObject
                                   :rules="notEmtpy"
                                   v-if="dialog.name === 'addSupplementDialog' && componentFrom === 'protocol'"
                                   :background-color="'#EDF2F7'"
                    />
                  </v-col>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2 d-flex align-center justify-space-around select-brand">
                  <div class="add-supplement-dialog__label mr-1">Select Brand </div>
                  <Select
                    outlined
                    itemText="name"
                    itemValue="id"
                    radius="8"
                    :items="brands"
                    :value="form.brandId"
                    :rules="notEmtpy"
                    @change="form.brandId = $event"
                  />
                  <Button btn-bg="dark-green"
                          dark
                          width="30"
                          height="30"
                          :styles="{ 'border-radius': '8px', 'font-weight': '600' }"
                          @click="addNewBrand">
                    <span style="color: #FFFFFF">
                      <v-icon>mdi-plus</v-icon>
                    </span>
                  </Button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :title="'Days Per Week'"
                    :countBtns="7"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.daysPerWeek"
                    @setData="form.daysPerWeek = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'upon-arising'"
                    :title="'Upon Arising'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosageUponArising"
                    @setData="form.dosageUponArising = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'breakfast'"
                    :title="'Breakfast'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosageBreakfast"
                    @setData="form.dosageBreakfast = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'10am'"
                    :title="'10 am'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosage10am"
                    @setData="form.dosage10am = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'lunch'"
                    :title="'Lunch'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosageLunch"
                    @setData="form.dosageLunch = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'3pm'"
                    :title="'3 pm'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosage3pm"
                    @setData="form.dosage3pm = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'dinner'"
                    :title="'Dinner'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosageDinner"
                    @setData="form.dosageDinner = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'7pm'"
                    :title="'7 pm'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosage7pm"
                    @setData="form.dosage7pm = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <custom-radio-button
                    :iconName="'before-sleep'"
                    :title="'Before Sleep'"
                    :countBtns="5"
                    :type="'range'"
                    :waysToColorCircles="'range'"
                    :propertyKeyValue="form.dosageBeforeSleep"
                    @setData="form.dosageBeforeSleep = $event"
                  ></custom-radio-button>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2 ml-2">
                  <v-switch class="py-0 my-0" color="#008C89" inset :disabled="form.discontinued" v-model="form.isDefault">
                    <template v-slot:label>
                      <span style="color: #008C89">Default Supplement</span>
                    </template>
                  </v-switch>
                  <v-switch class="py-0 my-0 pl-2" color="#008C89" inset v-model="form.discontinued">
                    <template v-slot:label>
                      <span style="color: #008C89">Discontinued</span>
                    </template>
                  </v-switch>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row class="add-supplement-dialog__label justify-center mt-3">Supplement Details</v-row>
                <v-row class="pl-2 pr-3 mb-2" style="margin-top: -22px">
                  <v-col cols="4" class="pb-0 mb-2">
                    <div class="d-flex add-supplement-dialog__bp">
                      <v-checkbox
                        color="#008C89"
                        v-model="form.vegetarian"
                        label="Vegetarian"/>
                    </div>
                    <div class="d-flex add-supplement-dialog__bp">
                      <v-checkbox
                        color="#008C89"
                        class="pt-0 mt-0"
                        v-model="form.glutenFree"
                        label="Gluten free"/>
                    </div>
                  </v-col>
                  <v-col cols="6" class="pb-0 mb-2">
                    <div class="d-flex add-supplement-dialog__bp">
                      <v-checkbox
                        color="#008C89"
                        v-model="form.warningLowBP"
                        label="Warning low BP"/>
                    </div>
                    <div class="d-flex add-supplement-dialog__bp">
                      <v-checkbox
                        color="#008C89"
                        class="pt-0 mt-0"
                        v-model="form.warningHighBP"
                        label="Warning high BP"/>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2" style="margin-top: -15px">
                  <v-col class="pb-0 pt-1" cols="6">
                    <div class="add-supplement-dialog__label">Quantity Type</div>
                    <Select
                      outlined
                      itemText="text"
                      itemValue="id"
                      radius="8"
                      :items="quantityTypes"
                      :value="form.quantityType"
                      @change="form.quantityType = $event"
                    /><!--:value="form.quantityType || quantityTypes[0].code"-->
                  </v-col>
                  <v-col v-if="['OZ', 'Gram', 'ML', 'O'].includes(form.quantityType)" class="pb-0 pt-1" cols="6">
                    <div class="add-supplement-dialog__label">Dosage Type</div>
                    <Select
                      outlined
                      itemText="text"
                      itemValue="id"
                      radius="8"
                      :items="dosageTypes"
                      :value="form.dosageSuffix"
                      @change="form.dosageSuffix = $event"
                    /><!--:value="form.dosageSuffix || dosageTypes[0].code"-->
                  </v-col>
                </v-row>
                <v-row class="pl-2 pr-3 mb-2" style="margin-top: -25px">
                  <v-col class="pb-0 mb-2 pt-1">
                    <div class="d-flex add-supplement-dialog__bp">
                      <v-checkbox
                        color="#008C89"
                        class="pt-1 pb-1"
                        v-model="form.printShortDescriptionReports"
                        label="Print my Short Description on Reports"/>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="add-supplement-dialog__label justify-center"
                       :style="{'margin-top': componentFrom === 'tab-supplement' ? '10px' : '8px'}">
                  {{componentFrom === 'protocol' ? 'Notes for this Protocol' : 'Supplement Notes'}}
                </v-row>
                <v-row class="pl-2 pr-3 mb-2">
                  <v-expansion-panels flat v-model="computedPanel" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        My short description (English)
                      </v-expansion-panel-header>
                      <v-expansion-panel-content color="#EDF2F7">
                        <Textarea dense auto-grow rows="1" rows-height="4" outlined @input:text-area="form.shortDesc=$event" :value="form.shortDesc" />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        My short description (Spanish)
                      </v-expansion-panel-header>
                      <v-expansion-panel-content color="#EDF2F7">
                        <Textarea dense auto-grow rows="1" rows-height="4" outlined @input:text-area="form.shortDescSpanish=$event" :value="form.shortDescSpanish" />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Patient Notes (English)
                      </v-expansion-panel-header>
                      <v-expansion-panel-content color="#EDF2F7">
                        <Textarea dense auto-grow rows="1" rows-height="4" outlined @input:text-area="form.patientNotes=$event" :value="form.patientNotes" />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Patient Note (Spanish)
                      </v-expansion-panel-header>
                      <v-expansion-panel-content color="#EDF2F7">
                        <Textarea dense auto-grow rows="1" rows-height="4" outlined @input:text-area="form.patientNotesSpanish=$event" :value="form.patientNotesSpanish" />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        My internal Notes
                      </v-expansion-panel-header>
                      <v-expansion-panel-content color="#EDF2F7">
                        <Textarea rows="1" rows-height="4" dense auto-grow outlined @input:text-area="form.clinicianNotes=$event" :value="form.clinicianNotes" />
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-row>
                <v-row style="margin-top: 50px">
                  <v-col class="py-0">
                    <div class="d-flex justify-space-between">
                      <Button :styles="{ 'border-radius': '8px', 'border': '1px solid #EDF2F7', 'background': 'white' }"
                              width="99"
                              height="53"
                              @click="close">
                        <span style="color: #425466;font-weight: 600;font-size: 14px;">Cancel</span>
                      </Button>
                      <Button btn-bg="dark-green"
                              dark
                              width="180"
                              height="53"
                              :disabled="!form.name || !form.brandId || !form.quantityType || (['OZ', 'Gram', 'ML', 'O'].includes(form.quantityType) && !form.dosageSuffix)"
                              :styles="{ 'border-radius': '8px', 'font-weight': '600' }"
                              v-if="dialog.name == 'addSupplementDialog'"
                              @click="add">
                        <span>Save</span>
                      </Button>
                      <Button btn-bg="dark-green"
                              dark
                              width="180"
                              height="53"
                              :styles="{ 'border-radius': '8px', 'font-weight': '600' }"
                              v-else
                              @click="update">
                        <span>Update</span>
                      </Button>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </template>
          </v-row>
        </v-form>
      </template>
    </Dialog>
    <modal-add-brand v-if="dialogs.modalAddNewBrand.isOpen" @update="handlerEvent"/>
    <div class="custom-alert">
      <v-alert
        :color="alertColor"
        dismissible
        type="info"
        v-model="alertIsOpen"
      >
        <span style="font-size: 14px;">{{message || 'Visit was completed. Please check the available Reports'}}</span>
      </v-alert>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

import Dialog from '@/components/layouts/dialog'
import Validation from '@/mixins/Validation'

import SearchSelect from '@/components/elements/search-select'
import Button from '@/components/elements/Button'
import Textarea from '@/components/elements/Textarea'
import CustomRadioButton from '@/components/elements/custom-radio-button'

import debounce from 'lodash/debounce'
import Input from '@/components/elements/Input'
import Select from '@/components/elements/Select'
import ModalAddBrand from '@/components/layouts/dialogs/modal-add-brand.vue'
import { trackEvent } from '@/utils/analytics'

export default {
  name: 'add-supplement-dialog',
  props: {
    query: Object,
    componentFrom: String
  },
  mixins: [Validation],
  components: { ModalAddBrand, Dialog, Button, CustomRadioButton, Textarea, SearchSelect, Input, Select }, // SearchSelect, Input, SpinInput, Textarea, Input
  data: () => ({
    // panel: [0, 1],
    alertColor: '#7ac1fb',
    alertIsOpen: false,
    message: null,
    panelSupplementNotes: [0, 1, 2],
    form: {
      name: '',
      supplementName: '',
      daysPerWeek: 7,
      discontinued: false,
      dosageUponArising: 0,
      dosageBreakfast: 0,
      dosage10am: 0,
      dosageLunch: 0,
      dosage3pm: 0,
      dosageDinner: 0,
      dosage7pm: 0,
      dosageBeforeSleep: 0,
      // daysPerWeek: 7,
      id: '',
      warnings: '',
      patientNotes: '',
      patientNotesSpanish: '',
      clinicianNotes: '',
      shortDesc: '',
      shortDescSpanish: '',
      supplementId: '',
      warningLowBP: false,
      warningHighBP: false,
      vegetarian: false,
      glutenFree: false,
      printShortDescriptionReports: false,
      quantityType: null,
      dosageSuffix: null,
      brandId: null,
      isDefault: false
    },
    supplementNotes: {
      patientEnglish: '',
      patientSpanish: '',
      internal: ''
    },
    supplements: [],
    searchValue: ''
  }),
  async created () {
    // await this.getBrands()
    if (this.dialog.name === 'editSupplementDialog') {
      if (this.dialog.type === 'protocol') {
        await this.getSupplementById({ id: this.dialog.id })
        this.form = Object.assign({}, this.protocolSupplementById)
        Object.assign(this.supplementNotes, {
          patientEnglish: this.protocolSupplementById.patientNotes,
          patientSpanish: this.protocolSupplementById.patientNotesSpanish,
          internal: this.protocolSupplementById.internalNotes
        })
      } else {
        await this.getDefaultDosagesBySupplement(this.dialog.id)
        this.form = Object.assign({}, this.supplementById)
      }
    }
  },
  methods: {
    ...mapActions('supplements', ['getSupplements', 'addSupplement', 'supplementsDropdown', 'updateSupplement', 'getDefaultDosagesBySupplement']),
    ...mapActions('protocols', ['getProtocols', 'getSupplementById', 'updateProtocolSupplement', 'addProtocolSupplement']),
    ...mapActions('brands', ['getBrands']),
    ...mapMutations('dialogs', ['TOGGLE_DIALOG']),
    async add () {
      if (this.validate()) {
        if (this.dialog.type === 'protocol') {
          await this.addProtocolSupplement({ protocolId: this.dialog.protocolId, ...this.form })
          trackEvent(this, 'add_protocol_supplement', 'Supplement', 'Protocol Supplement Was Added')
        } else {
          this.form.dosageType = this.form.dosageSuffix
          await this.addSupplement({ ...this.form })
          trackEvent(this, 'add_supplement', 'Supplement', 'Supplement Was Added')
        }
        const { afterAction } = this.dialog
        await this.$store.dispatch(afterAction.name, afterAction.protocol)
        this.close()
      }
    },
    async update () {
      let res = null
      if (this.dialog.type === 'protocol') {
        res = await this.updateProtocolSupplement({ ...this.form })
        if (res) {
          this.getProtocols(this.query)
          trackEvent(this, 'update_protocol_supplement', 'Supplement', 'Protocol Supplement Was Updated')
        }
      } else {
        this.form.dosageType = this.form.dosageSuffix
        res = await this.updateSupplement({ ...this.form })
        if (res) {
          trackEvent(this, 'update_supplement', 'Supplement', 'Supplement Was Updated')
        }
      }
      if (res) {
        this.getSupplements(this.query)
      }
      this.close()
    },
    close () {
      this.TOGGLE_DIALOG({ name: this.dialog.name, isOpen: false })
    },
    addNewBrand () {
      this.TOGGLE_DIALOG({ name: 'modalAddNewBrand', isOpen: true, title: 'Add new Brand' })
    },
    async handlerEvent (id) {
      if (id) {
        await this.getBrands()
        this.form.brandId = this.brands.find(brand => brand.id === id).id
        this.alertIsOpen = true
        this.alertColor = '#7ac1fb'
        this.message = `New Brand name was created`
      } else {
        this.alertIsOpen = true
        this.alertColor = '#CF4655'
        this.message = `Occurred some error`
      }
      const self = this
      setTimeout(function () {
        self.alertIsOpen = false
      }, 3000)
    }
  },
  computed: {
    ...mapState({
      visit: state => state.visits?.visit,
      dialog (state) {
        const modalName = this._.findKey(state.dialogs, function(item) { return item.isOpen && ['editSupplementDialog', 'addSupplementDialog'].includes(item.name) })
        return state.dialogs[modalName]
      },
      supplementById: state => state.supplements?.supplementById,
      protocolSupplementById: state => state.protocols?.supplementById,
      quantityTypes: state => state.settings.patients.quantityTypes.$values.map(item => {
        return {
          ...item,
          text: item.name,
          value: item.code,
          id: item.code
        }
      }),
      dosageTypes: state => state.settings.patients.dosagesTypes.$values.map(item => {
        return {
          ...item,
          text: item.name,
          value: item.code,
          id: item.code
        }
      }),
      brands: state => state.brands.brands || []
    }),
    dialogs () {
      return this.$store.state.dialogs
    },
    computedPanel () {
      if (this.componentFrom === 'tab-supplement') {
        return []
      } else {
        return [0, 1]
      }
    }
  },
  watch: {
    'form.discontinued'(val) {
      if (val) {
        this.form.isDefault = false
      }
    },
    searchValue: debounce(async function (val) {
      if (val) {
        const result = await this.supplementsDropdown(val)
        this.supplements = result?.$values
      } else {
        this.supplements = []
      }
    }, 1000),
    'form.id': async function (val) {
      if (this.dialog.name !== 'editSupplementDialog') {
        if (this.dialog.type === 'protocol') {
          const result = await this.getSupplementById(val)
          Object.assign(this.form, {
            dosageUponArising: result.dosageUponArising,
            dosageBreakfast: result.dosageBreakfast,
            dosage10am: result.dosageUponArising,
            dosageLunch: result.dosage10am,
            dosage3pm: result.dosage3pm,
            dosageDinner: result.dosageDinner,
            dosage7pm: result.dosage7pm,
            dosageBeforeSleep: result.dosageBeforeSleep
          })
        } else {
          const result = await this.getDefaultDosagesBySupplement(this.dialog.id)
          this.searchValue = result.name
        }
      }
    },
    'form.supplementId': async function (val) {
      if (this.dialog.name === 'addSupplementDialog' && this.componentFrom === 'protocol') {
        const result = await this.getDefaultDosagesBySupplement(val)
        Object.assign(this.form, {
          dosageUponArising: result.record.dosageUponArising,
          dosageBreakfast: result.record.dosageBreakfast,
          dosage10am: result.record.dosageUponArising,
          dosageLunch: result.record.dosage10am,
          dosage3pm: result.record.dosage3pm,
          dosageDinner: result.record.dosageDinner,
          dosage7pm: result.record.dosage7pm,
          dosageBeforeSleep: result.record.dosageBeforeSleep
        })
        Object.assign(this.supplementNotes, {
          patientEnglish: result.record.patientNotes,
          patientSpanish: result.record.patientNotesSpanish,
          internal: result.record.internalNotes
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-supplement-dialog {
  .custom-alert {
    max-width: 300px;
    position: fixed;
    top: 10px;
    right: 20px;
    z-index: 999;
  }
  .select-brand {
    ::v-deep .v-input {
      width: 200px;
    }
  }
  ::v-deep .v-dialog {
    overflow-y: hidden!important;
    max-height: unset!important;
    &__container {
      .v-card {
        &__title {
          background: #edf2f7;
          padding: 25px 30px 17px 46px !important;
          justify-content: center!important;
          position: relative;
          .v-icon {
            position: absolute;
            right: 15px;
            top: 25px;
          }
        }
        &__text {
          overflow-y: scroll;
          max-height: 605px; // 595px;
          padding: 16px!important;
          background-color: white!important;
        }
      }
    }
  }
  &____bp {
    ::v-deep .v-input {
      padding: 10px 13px 10px 13px;
      label {
        font-size: 14px;
        font-weight: 500;
      }
      &:hover {
        background: #F7FAFC;
        border-radius: 8px;
      }
    }
      &__control {
        .v-messages {
          display: none;
        }
      }
    }
  .patient-name {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
  }
  .supply-days {
    font-style: normal;
    &__title {
      font-weight: normal;
      font-size: 14px;
      line-height: 23px;
      color: #718096;
    }
    &__count {
      font-weight: 600;
      font-size: 14px;
      line-height: 23px;
      color: #425466;
    }
  }
  &__label {
    font-weight: bold;
    line-height: 21px;
    font-size: 16px;
    color: #425466;
  }
  ::v-deep .search-select {
    .v-input {
      .v-input__control {
        .v-input__slot {
          border-radius: 8px !important;
          input {
            padding-left: 8px;
          }
        }
        .v-input__slot:before {
          width: 0 !important;
        }
      }
    }
  }
  ::v-deep .v-expansion-panels {
    .v-expansion-panel:not(.v-item--active) {
      //border-bottom: 1px solid #E2E8F0;
      .v-expansion-panel-header {
        padding: 16px 10px !important;
      }
      v-expansion-panel-header--active {
        padding: 16px 10px !important;
      }
      .v-expansion-panel-content {
        border-radius: 8px;
      }
    }
    .v-expansion-panel {
      //border-bottom: 1px solid #E2E8F0;
      .v-expansion-panel-header {
        padding: 16px 10px !important;
      }
      v-expansion-panel-header--active {
        padding: 16px 10px !important;
      }
      .v-expansion-panel-content {
        border-radius: 8px;
      }
    }
  }
  &__spin-input {
    ::v-deep .v-text-field__details {
      display: none !important;
    }
  }
  ::v-deep .select .v-text-field {
    &__details {
      display: none;
    }
  }
  ::v-deep .button {
    .v-btn.v-btn--disabled {
      background-color: #EBF2FA!important;
      color: white!important;
    }
  }
}
</style>
